module.exports = __webpack_public_path__ + "static/media/warning.cd98cf84.svg";